import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'

import { WarningMessageDialogComponent } from './warning-message-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    TranslateModule,
    MatDialogModule,
  ],
  exports: [
    WarningMessageDialogComponent,
  ],
  declarations: [
    WarningMessageDialogComponent,
  ],
  providers: [],
})
export class WarningMessageDialogModule { }
